import { RouteName } from "constant/routeNames";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setVideoStart, setVideoSuccess } from "redux/VideoPlayerRedux";

function SingleEpisode({ data, id, season }: any) {
  const dispatch = useDispatch<any>();
  const { currentVideo } = useSelector((state: any) => state?.video);
  const navigate = useNavigate();
  const { slug }: any = useParams();

  const episodeOnClick = () => {
    const value = {
      ...data,
      tv_series_id: id,
      season: season,
      poster_image: data.thumbnail,
    };
    navigate(
      RouteName.WatchTVSeries.replace(":slug", slug).replace(
        ":stream",
        value?.stream_key
      )
    );

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    console.log("episode clisk", value);
    // dispatch(setVideoStart());
    // dispatch(setVideoSuccess(value));

    // window.location.reload();
  };

  const isActive = currentVideo.id === data.id;

  return (
    <div
      className={`group my-3 flex w-[411px] min-h-[76px] cursor-pointer items-center gap-3 overflow-hidden rounded-xl border p-2 transition-all duration-200 max-sm:w-full ${
        isActive
          ? "border-[#F50537]/50 bg-[#F50537]/10"
          : "border-white/10 bg-white/[0.03] hover:border-white/20 hover:bg-white/[0.06]"
      }`}
      onClick={episodeOnClick}
    >
      {/* image */}
      <div
        className={`relative shrink-0 overflow-hidden rounded-lg bg-cover ${
          isActive ? "h-[68px] w-[120px]" : "h-[60px] w-[110px]"
        }`}
      >
        <img
          src={data.thumbnail}
          alt="thumbnail"
          className="h-full w-full object-cover"
        />
        {isActive && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/40">
            <span className="h-2 w-2 animate-pulse rounded-full bg-[#F50537]" />
          </div>
        )}
      </div>
      {/* details */}
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-semibold uppercase tracking-wide text-white/40">
          {data.season_name}
        </p>
        <p
          className={`line-clamp-1 text-[14px] font-medium max-sm:w-full ${
            isActive ? "text-white" : "text-white/80 group-hover:text-white"
          }`}
        >
          {data.title}
        </p>
        {isActive && data.description && (
          <p className="mt-0.5 line-clamp-1 text-[11px] text-white/50 max-sm:w-full">
            {data.description}
          </p>
        )}
      </div>
    </div>
  );
}

export default SingleEpisode;
